import React from 'react';
import { NavLink } from '../../../molecules/Links/NavLink';

export const createLinks = pageRoutes => {
  const routes = [];
  pageRoutes.forEach((route, key) => {
    !route.hide &&
      routes.push(
        <NavLink
          key={key}
          linkName={route.linkName}
          icon={route.icon}
          link={route.path}
          isExternal={route.external}
        />
      );
  });
  return routes;
};

export const createLinksBurgerMenu = pageRoutes => {
  const routes = [];
  pageRoutes.forEach((route, key) => {
    !route.hide &&
      route.linkName !== 'Dashboard' &&
      route.linkName !== 'Reporting' &&
      route.linkName !== 'Pédagogie' &&
      routes.push(
        <NavLink
          key={key}
          linkName={route.linkName}
          link={route.path}
          isExternal={route.external}
          isOnBurgerMenu={true}
        />
      );
  });
  return routes;
};
